import { Button } from "antd";
import MessageFormValidateV2 from "components/Common/MessageFormValidateV2";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { ORDER_TYPE, TRANSFER_ORDER_TYPE } from "constants/order";
import { useAddChildTransferOrders, useRemoveChildTransferOrder } from "hooks";
import { useResourceGlobalPreview } from "hooks/resource-global/useResourceGlobal";
import { orderStatusMode } from "pages/Orders/utils";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Lightbox from "react-image-lightbox";
import { useToasts } from "react-toast-notifications";
import { Alert, Card, CardBody, Row } from "reactstrap";
import SearchOrderChildModal from "./Modal/SearchOrderChildModal";
import "./TransferOrderChild.scss";

const TransferOrderChild = React.forwardRef((props, ref) => {
  const {
    title,
    parent_id,
    pathDetail,
    mainForm,
    fieldChildName,
    fieldChildSelectedName,
    fieldSearchOrderToAddName,
    orderStatusList,
    isShowBtnDeleteChild,
    isShowBtnAddChild = false,
    isDeleteTemp = false,
    extraButton,
    isShowRowsSelected = false,
    onSuccessRemoveChild,
    onSuccessAddChild,
    transferOrderType,
    setOrderChildParams,
    isShowSearch = false,
  } = props;

  const { addToast } = useToasts();
  const {
    formState: { errors, touchedFields },
    setValue,
    watch,
  } = mainForm;

  const fieldChildData = watch(fieldChildName);
  const fieldChildSelectedData = watch?.(fieldChildSelectedName);

  const { t } = useTranslation(["order"]);

  const [isOpenModalSearch, setIsOpenModalSearch] = useState(false);
  const toggleModalSearch = () => {
    setIsOpenModalSearch(!isOpenModalSearch);
  };

  const [columnsTable, setColumnsTable] = useState([]);
  const [isDeleteLastChild, setIsDeleteLastChild] = useState(false);

  const [data, setData] = useState(null);

  const onChildListSuccess = response => {
    const listData = response?.items || [];
    setData(response);
    setValue(fieldChildName, listData);
    fieldChildSelectedName && setValue(fieldChildSelectedName, []);
  };

  useEffect(() => {
    setColumnsTable(initColumns);
  }, [orderStatusList]);

  const getOrderStatusLabel = useCallback(
    status => {
      return orderStatusList?.find(
        orderStatus => status?.toString() === orderStatus.value
      )?.label;
    },
    [orderStatusList]
  );

  const [resourceId, setResourceId] = useState(undefined);
  const [isPreviewImage, setIsPreviewImage] = useState(false);

  const {
    data: resourceData,
    isLoading: isLoadingResource,
    refetch: fetchResourceGlobalPreview,
  } = useResourceGlobalPreview({
    resourceId,
  });

  useEffect(() => {
    if (resourceId) {
      fetchResourceGlobalPreview();
    }
  }, [resourceId]);

  const viewImage = id => {
    setResourceId(id);
    setIsPreviewImage(true);
  };

  React.useImperativeHandle(ref, () => ({
    refreshChildrenList() {
      fieldChildSelectedName && setValue(fieldChildSelectedName, []);
    },

    clearChildrenList() {
      setData(null);
      setValue(fieldChildName, []);
      fieldChildSelectedName && setValue(fieldChildSelectedName, []);
    },

    setChildrenList(listData) {
      setValue(fieldChildName, listData);
      fieldChildSelectedName && setValue(fieldChildSelectedName, []);
    },

    addChild(data) {
      if (fieldChildData?.find(l => l?.order_code === data?.order_code)) {
        addToast("Mã đơn này đã quét", {
          appearance: "warning",
          autoDismiss: true,
        });
      } else {
        setValue(fieldChildName, [...fieldChildData, data]);
        setValue(fieldChildSelectedName, [...fieldChildSelectedData, data]);
      }
    },

    addListChildOfParent(data) {
      setValue(fieldChildName, data);
      setValue(fieldChildSelectedName, data);
    },
  }));

  const initColumns = [
    {
      dataField: "index",
      text: "STT",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "maker_date",
      text: t("detail.order_child.maker_time"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      formatter: (cell, row) => {
        console.log("cell", cell);
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
    },
    {
      dataField: "order_code",
      text: t("detail.order_child.order_code"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      formatter: (cell, row) => {
        return (
          <span
            title="Xem đơn con"
            className="text-primary"
            style={{ fontWeight: "bold", cursor: "pointer" }}
            onClick={() => {
              row.type === ORDER_TYPE.COLLECTOR.value
                ? window.open(`/collection-order/${row?.id}`, "_blank")
                : window.open(`/${pathDetail}/${row?.id}`, "_blank");
            }}
          >
            {cell}
          </span>
        );
      },
    },
    {
      dataField: "ref_code",
      text: t("detail.order_child.ref_code"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
    },
    {
      dataField: "status",
      text: t("detail.order_child.status"),
      sort: true,
      formatter: cell => {
        return getOrderStatusLabel(cell);
      },
    },
    {
      dataField: "sender_name",
      text: t("detail.order_child.customer"),
      sort: true,
      formatter: (cell, row) => {
        return row.type === 1 ? row.reciever_name : row.sender_name;
      },
    },
    {
      dataField: "transport_name",
      text: t("detail.order_child.transport_name"),
      sort: true,
    },
    {
      dataField: "imagePath",
      text: t("detail.order_child.image_receive"),
      formatter: (cell, row) => {
        return cell ? (
          <Button
            type="link"
            size="small"
            onClick={() => viewImage(cell)}
            loading={isLoadingResource}
          >
            <i
              style={{ fontSize: "20px" }}
              className="fa fa-regular fa-image "
            ></i>
          </Button>
        ) : (
          <></>
        );
      },
      align: "center",
    },
    // {
    //   dataField: "sender_contact_phone",
    //   text: t("detail.order_child.SDT"),
    //   sort: true,
    //   formatter: (cell, row) => {
    //     return row.type === 1
    //       ? row.reciever_contact_phone
    //       : row.sender_contact_phone;
    //   },
    // },
    // {
    //   dataField: "address",
    //   text: t("detail.order_child.address"),
    //   sort: true,
    //   formatter: (cell, row) => {
    //     const address =
    //       row.type === 2 ? row.sender_full_address : row.reciever_full_address;

    //     return <div style={{ whiteSpace: "break-spaces" }}>{address}</div>;
    //   },
    // },
  ];

  const onSuccessRemoveChildTransferOrder = res => {
    onSuccessRemoveChild(res);
  };

  const {
    mutate: mutateRemoveChildTransferOrder,
    isLoading: isLoadingRemoveChildTransferOrder,
  } = useRemoveChildTransferOrder(onSuccessRemoveChildTransferOrder);

  const onSuccessAddChildTransferOrder = res => {
    onSuccessAddChild(res);
  };

  const {
    mutate: mutateAddChildTransferOrder,
    isLoading: isLoadingAddChildTransferOrder,
  } = useAddChildTransferOrders(onSuccessAddChildTransferOrder);

  const conditionVisibleDeleteChild =
    transferOrderType === TRANSFER_ORDER_TYPE.RECEIVE
      ? {
          status: [
            orderStatusMode.RECEIVED,
            orderStatusMode.HUB_RECEIVED,
            orderStatusMode.IN_TRANSIT,
            orderStatusMode.DELIVERED,
          ], // Đơn nhận mẫu: Trạng thái "Đã nhận hàng" "Đã đến HUB" "Đang trung chuyển" "Đã giao hàng"
          type: [TRANSFER_ORDER_TYPE.RECEIVE],
        }
      : {
          status: [
            orderStatusMode.MAKE,
            orderStatusMode.IN_TRANSIT,
            orderStatusMode.HUB_RECEIVED,
          ], // Đơn trả kết quả: Trạng thái "Tạo mới" "Đang trung chuyển" "Đã đến Hub"
          type: [TRANSFER_ORDER_TYPE.RETURN],
        };

  const listRowAction = [
    {
      icon: <i className="fas fa-trash fa-lg text-danger" />,
      text: "Xóa đơn con",
      conditionVisible: parent_id && conditionVisibleDeleteChild,
      onClick: row => {
        if (fieldChildData && fieldChildData.length < 2) {
          setIsDeleteLastChild(true);
          return;
        }

        if (isDeleteTemp) {
          const dataChange = fieldChildData?.filter(c => c.id !== row.id);

          setValue(fieldChildName, dataChange);

          if (fieldChildSelectedName) {
            const dataSelectedChange = fieldChildSelectedData?.filter(
              c => c.id !== row.id
            );
            setValue(fieldChildSelectedName, dataSelectedChange);
          }
        } else {
          mutateRemoveChildTransferOrder({
            order_codes: [row.order_code],
          });
        }
      },
    },
  ];

  const handleRowsSelect = (ids, row) => {
    const dataChange = fieldChildData?.filter(d => {
      const selected = ids?.find(id => id === d?.id) ? true : false;
      return selected;
    });
    fieldChildSelectedName && setValue(fieldChildSelectedName, dataChange);
  };
  const onSearchAllHandle = value => {
    setOrderChildParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  return (
    <Card className="TransferOrderChild">
      <CardBody>
        <div className="d-flex align-items-center gap-2 justify-content-between">
          <h5>
            {title || `${t("detail.order_child.title")}`}
            {` (${fieldChildData?.length || 0})`}
          </h5>

          <div>
            {" "}
            {isShowBtnAddChild && (
              <Button
                className="mb-2 w-100"
                color={"primary"}
                type="button"
                onClick={() => {
                  toggleModalSearch();
                }}
              >
                {"Thêm đơn con"}
              </Button>
            )}
            {extraButton && extraButton}
          </div>
        </div>
        <SearchOrderChildModal
          fieldChildName={fieldChildName}
          fieldSearchOrderToAddName={fieldSearchOrderToAddName}
          mainForm={mainForm}
          orderStatusList={orderStatusList}
          isOpen={isOpenModalSearch}
          toggle={toggleModalSearch}
          t={t}
          onAddSearchOrder={listOrderAdd => {
            if (parent_id) {
              mutateAddChildTransferOrder({
                order_id: parent_id,
                sub_order_codes: listOrderAdd?.map(o => o?.order_code),
              });
            } else {
              setValue(fieldChildName, [...fieldChildData, ...listOrderAdd]);
            }
          }}
        />
        <Row>
          <Alert
            color="danger"
            isOpen={isDeleteLastChild}
            toggle={() => setIsDeleteLastChild(prev => !prev)}
          >
            {t("message.delete_last_child")}
          </Alert>
        </Row>
        <RemoteDataTable
          selectRow={
            isShowRowsSelected && {
              mode: "checkbox",
              clickToSelect: true,
              bgColor: "#00BFFF",
              selected: fieldChildSelectedData?.map(d => d?.id) || [],
            }
          }
          onRowsSelect={handleRowsSelect}
          isShowSearchAll={isShowSearch}
          classNameTable={"child-table"}
          isShowPagination={false}
          listRowAction={isShowBtnDeleteChild && listRowAction}
          isShowRowIndex={false}
          keyField="id"
          data={fieldChildData?.map((c, i) => {
            return {
              index: i + 1,
              ...c,
            };
          })}
          columns={columnsTable}
          page={data?.params?.page}
          sizePerPage={data?.params?.sizePerPage}
          totalSize={data?.totalCount}
          loading={
            isLoadingAddChildTransferOrder || isLoadingRemoveChildTransferOrder
          }
          onSearchAllHandle={onSearchAllHandle}
        ></RemoteDataTable>
        {isPreviewImage && !isLoadingResource && (
          <Lightbox
            mainSrc={resourceData}
            enableZoom={true}
            onCloseRequest={() => {
              setResourceId(undefined);
              setIsPreviewImage(false);
            }}
          />
        )}

        <MessageFormValidateV2 errors={errors} fieldName={fieldChildName} />
      </CardBody>
    </Card>
  );
});

TransferOrderChild.propTypes = {
  isShowRowsSelected: PropTypes.any,
  parent_id: PropTypes.any,
  orderStatusList: PropTypes.array,
  pathDetail: PropTypes.any,
  extraButton: PropTypes.any,
  isShowBtnDeleteChild: PropTypes.any,
  isShowBtnAddChild: PropTypes.any,
  onSuccessRemoveChild: PropTypes.any,
};

export default TransferOrderChild;
